import { render, staticRenderFns } from "./VocabularyMemoRusForm.vue?vue&type=template&id=68a00b28&scoped=true&lang=pug&"
import script from "./VocabularyMemoRusForm.vue?vue&type=script&lang=js&"
export * from "./VocabularyMemoRusForm.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyMemoRusForm.vue?vue&type=style&index=0&id=68a00b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a00b28",
  null
  
)

export default component.exports